import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const DesignationScheme = () => {
  return (
    <div className="about-us">

      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Designation Scheme</h1>
          <p className="subtitle">
            This scheme certifies services offered to clients that comply with Malawi Standards.
          </p>
          
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="what-section">
        <h2 className="section-title">Overview</h2>

        <p className="paragraph">
        This scheme certifies services offered to clients that comply with service standards such as Malawi standard MS 21: Code of Hygienic Conditions for Food and Food Processing Units.  Under this scheme, units offering food services covered by specific Malawi Standards are inspected periodically and when their services consistently comply with relevant standards they are certified, whereby a Designation Certificate is issued for display in such complying premises.  A good example is the certification of catering services.
        
        </p>

        
      </section>

      <br /><br />

      {/* === Inline Styles === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .what-section { padding: 50px 80px; }
        .section-title {
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
        }

        .paragraph {
          font-size: 1rem;
          line-height: 1.7;
          margin: 15px 0;
          text-align: left;
        }

        .centered-text { text-align: center; }

        a {
          color: #ff6600;
          font-weight: bold;
          text-decoration: none;
        }

        a:hover { text-decoration: underline; }

        @media screen and (max-width: 768px) {
          .what-section { padding: 25px 20px; }
          .page-title { font-size: 2rem; }
          .overlay { width: 95%; padding: 25px; }
        }
      `}</style>

    </div>
  );
};

export default DesignationScheme;
